var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSendIconLatest(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.1211,
    cy: 17.1211,
    r: 16.7406,
    fill: "black",
    stroke: "black",
    strokeWidth: 0.760938
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1493 18.5764L12.472 18.8228M12.472 18.8228L13.3676 19.5067C13.7197 19.7756 14.2154 19.7477 14.5352 19.4409C15.2677 18.7382 16.4071 19.6263 15.942 20.5286C15.7412 20.9183 15.8467 21.3998 16.1951 21.6658L17.4735 22.642L18.3658 23.3235C18.914 23.742 19.7107 23.4291 19.8274 22.7493L20.1263 21.0078L20.6816 17.7719L21.4958 13.0283C21.6211 12.2983 20.8746 11.7282 20.2033 12.0413L15.8415 14.0758L12.8661 15.4637L11.2647 16.2106C10.6397 16.5022 10.5475 17.3532 11.0957 17.7718L12.472 18.8228Z",
    stroke: "#68FF9F",
    strokeWidth: 0.91776
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendIconLatest);
export default __webpack_public_path__ + "static/media/sendIconLatest.165e4c15494b09a414307e94f36d931d.svg";
export { ForwardRef as ReactComponent };